import { toDateString } from "../helpers";

export class OrganizationAffiliation {
    id?: number;
    displayName: string;
    isDeleted: boolean;
    affiliationMembership: OrganizationAffiliationMember[];
    leader?: OrganizationAffiliationMember;

    constructor(data?: OrganizationAffiliationData) {
        if (data) {
            this.id = data.id;
            this.displayName = data.displayName;
            this.isDeleted = data.isDeleted;
            this.affiliationMembership = data.affiliationMembership.map(x => {
                const member = new OrganizationAffiliationMember(x);
                if (member.affiliationRoleCode === AffiliationRoleCode.Leader) {
                    this.leader = member;
                }
                return member;
            });
        }
    }
}

export class OrganizationAffiliationMember {
    id?: number;
    organizationId: number;
    affiliationRoleCode: AffiliationRoleCode;
    activeFrom: Date;
    activeTo: Date;
    isDeleted: boolean;

    constructor(data?: OrganizationAffiliationMembershipData) {
        this.id = data.id;
        this.organizationId = data.organizationId;
        this.affiliationRoleCode = data.affiliationRoleCode;
        this.activeFrom = data.activeFrom ? new Date(data.activeFrom) : null;
        this.activeTo = data.activeTo ? new Date(data.activeTo) : null;
        this.isDeleted = data.isDeleted;
    }
}

export interface OrganizationAffiliationData {
    id: number;
    displayName: string;
    isDeleted: boolean;
    affiliationMembership: OrganizationAffiliationMembershipData[];
}

export interface OrganizationAffiliationMembershipData {
    id: number;
    organizationId: number;
    affiliationRoleCode: AffiliationRoleCode;
    activeFrom: string;
    activeTo: string;
    isDeleted: boolean;
}

export enum AffiliationRoleCode {
    Participant = "AffiliationRoleCode.Participant",
    Leader = "AffiliationRoleCode.Leader"
}

export function OrganizationAffiliationToData(
    affiliation: OrganizationAffiliation
): OrganizationAffiliationData {
    return {
        id: affiliation.id,
        displayName: affiliation.displayName,
        isDeleted: affiliation.isDeleted,
        affiliationMembership: affiliation.affiliationMembership.map(member => ({
            id: member.id,
            organizationId: member.organizationId,
            affiliationRoleCode: member.affiliationRoleCode,
            activeFrom: toDateString(member.activeFrom),
            activeTo: toDateString(member.activeTo),
            isDeleted: member.isDeleted
        }))
    };
}
